import { computed, ref } from 'vue';

export function useStageTimer(stageEnteredAt, timerData = {}) {
  // Calcula o tempo total no estágio
  const totalTimeInStage = computed(() => {
    if (!stageEnteredAt) return 0;

    const entered = new Date(stageEnteredAt);
    const now = new Date();
    let baseTime = Math.floor((now - entered) / 1000); // em segundos

    // Adicionar tempo pausado se houver
    if (timerData.paused_duration) {
      baseTime += timerData.paused_duration;
    }

    // Se timer está rodando, adicionar tempo desde que começou
    if (timerData.is_running && timerData.started_at) {
      const started = new Date(timerData.started_at);
      baseTime += Math.floor((now - started) / 1000);
    }

    return baseTime;
  });

  // Formata o tempo de forma legível
  const formattedTime = computed(() => {
    const seconds = totalTimeInStage.value;

    if (seconds < 60) {
      return 'Agora';
    }

    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (days > 0) {
      const remainingHours = hours % 24;
      if (remainingHours > 0) {
        return `${days}d ${remainingHours}h`;
      }
      return `${days}d`;
    }

    if (hours > 0) {
      const remainingMinutes = minutes % 60;
      if (remainingMinutes > 0) {
        return `${hours}h ${remainingMinutes}m`;
      }
      return `${hours}h`;
    }

    return `${minutes}m`;
  });

  // Formata tempo compacto para o card
  const compactTime = computed(() => {
    const seconds = totalTimeInStage.value;

    if (seconds < 3600) {
      // menos de 1 hora
      return 'Agora';
    }

    const hours = Math.floor(seconds / 3600);
    const days = Math.floor(hours / 24);

    if (days > 0) {
      return `${days}d`;
    }

    return `${hours}h`;
  });

  // Verifica se está próximo do SLA
  const isNearSLA = slaHours => {
    if (!slaHours) return false;

    const hoursInStage = totalTimeInStage.value / 3600;
    const threshold = slaHours * 0.8; // 80% do tempo

    return hoursInStage >= threshold;
  };

  // Verifica se violou o SLA
  const isSLABreached = slaHours => {
    if (!slaHours) return false;

    const hoursInStage = totalTimeInStage.value / 3600;
    return hoursInStage > slaHours;
  };

  // Classe CSS baseada no SLA
  const getSLAClass = slaHours => {
    if (isSLABreached(slaHours)) {
      return 'text-red-600 dark:text-red-400 bg-red-50 dark:bg-red-900/20';
    }
    if (isNearSLA(slaHours)) {
      return 'text-yellow-600 dark:text-yellow-400 bg-yellow-50 dark:bg-yellow-900/20';
    }
    return 'text-slate-500 dark:text-slate-400';
  };

  return {
    totalTimeInStage,
    formattedTime,
    compactTime,
    isNearSLA,
    isSLABreached,
    getSLAClass,
  };
}
